import * as React from "react";
import Component from "../../AbstractComponent";
import Logger from "../../../Logger/Logger";

import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";

export default class TextFieldWrapper extends Component {
  constructor(public props) {
    super(props);
  }

  public componentDidMount = () => {
    this.checkMandatoryProps();
  };

  public checkMandatoryProps = () => {
    if (typeof this.props.error === "undefined") {
      Logger.logError(
        new Error(
          `${location?.pathname}, <TextField> checkMandatoryProps(error): ${this.props.label}`
        ),
        "warning"
      );
    }
  };

  public render() {
    return (
      <TextField
        id={this.props.id}
        name={this.props.name}
        autoComplete={this.props.autoComplete}
        className={`${this.props.className} textfield-filled-styles`}
        type={this.props.type}
        label={this.props.label}
        value={this.props.value}
        placeholder={this.props.placeholder}
        onFocus={this.props.onFocus}
        onChange={this.props.onChange}
        onBlur={this.props.onBlur}
        onKeyPress={this.props.onKeyPress}
        onKeyDown={this.props.onKeyDown}
        autoFocus={this.props.autoFocus}
        // variant={this.props.variant}
        variant={this.props.globalSearch ? "standard" : "filled"}
        style={this.props.style}
        fullWidth={this.props.fullWidth}
        error={this.props.error}
        helperText={this.props.helperText}
        multiline={this.props.multiline}
        rowsMax={this.props.rowsMax}
        rows={this.props.rows}
        inputRef={this.props.inputRef}
        inputProps={this.props.inputProps}
        disabled={this.props.disabled}
        defaultValue={this.props.defaultValue}
        required={this.props.required}
        InputLabelProps={this.props.InputLabelProps}
        InputProps={{
          endAdornment: this.props.endAdornment ? (
            <InputAdornment position="end">%</InputAdornment>
          ) : (
            ""
          ),
        }}
      />
    );
  }
}
